<template src="@/templates/reservations/travel-package.html"></template>

<script>
import userApi from '@/api/userApi';
import entityStore from '@/store/entityStore';
import componentList from '@/components/reservations/component-list';

export default {
  props: [
    'reservationId',
  ],
  data() {
    return {
      reservation: {},
      // invoice: null,
      // vouchers: [],
      // participants: [],
      isLoading: true,
      // isLoadingVouchers: true,
      // isLoadingParticipants: true,
      entity: entityStore.state,
    };
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  },
  computed: {
    showTourLeader() {
      return entityStore.state.name !== 'aircruise';
    }
  },
  watch: {
    // call again the method if the route changes
    // $route: 'fetchData',
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      userApi.getReservation(this.reservationId, (data) => {
        this.reservation = data.reservation;
        this.isLoading = false;
      });
    },
    formatName(passenger) {
      return entityStore.formatPassengerName(passenger);
    },
    formatLongName(passenger) {
      return entityStore.formatPassengerNameLong(passenger);
    },
  },
  components: {
    componentList,
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// travel-package.vue?2f9b67e0